import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  exportConsumer: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/consumer/export-consumers`, {
      ...parameters,
    });
  },
  /**
   * Fetch the end consumer count report
   * @param {any} query - The query
   */
  endConsumerCountReport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/consumer/users-count`, {
      ...parameters,
    });
  },
  /**
   * Delete the user api call function
   * @param {any} id - The ID of the user to delete
   * @returns {any} A promise resolving to the delete result
   */
  deleteUser: (id: String): Promise<any> => {
    return deleteRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/consumer/users/${id}`);
  },

  /**
   * Fetch user info by id
   * @param {any} id - The id
   */
  fetchUserInfoById: (id: string) => {
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/consumer/${id}`);
  },
  /**
   * Fetch vehicle details of the consumer
   * @param {any} id - The id
   */
  fetchVehicleDetailsByUserCustomId: (id: string) => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/vehicle-management/consumer/${id}`);
  },
  /**
   * Fetch vehicle details of the consumer
   * @param {any} id - The id
   */
  fetchTransactionByUserCustomId: (id: string) => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/consumer-transaction-list/${id}`,
    );
  },
};
